import React from "react"

import { Wrapper, Content } from "./styles";
import HeaderPage from "../header";

export default function Layout({ headContent, backHistoryEvent, children }) {
    return (
        <Wrapper>
            <HeaderPage onClick={backHistoryEvent}>
                {headContent}
            </HeaderPage>
            <Content>
                {children}
            </Content>
        </Wrapper>
    )
}
